import { call, select, take } from 'redux-saga/effects';

import { UPDATE_HIGHLIGHT } from './actions';

import { updateHighlight as vsUpdateHighlight } from 'services/learnkit';


function* update() {
  while (true) {
    const { data:{ markerId, selectedHighlight } } = yield take(UPDATE_HIGHLIGHT);

    const { id, noteText } = selectedHighlight;

    yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });

    // LST-1595 make api call and `highlight:updated` VS event will handle updating redux state
    yield call(vsUpdateHighlight, id, markerId, noteText);
  }
}


export default update;
